import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock, User, KeyRound, ShieldCheck, Building2 } from 'lucide-react';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login, authError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = (e) => {
    e.preventDefault();
    const result = login(username, password);
    if (result.success) {
      navigate(from, { replace: true });
    }
  };

  const handleFillDemo = () => {
    setUsername('admin');
    setPassword('admin123');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        backgroundColor: '#090D16',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
    >
      <div style={{ width: '100%', maxWidth: '410px' }}>
        {/* Brand Header with 3 TBS Corporate Color Accents */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ display: 'inline-flex', gap: '4px', marginBottom: '10px' }}>
            <span style={{ width: 24, height: 4, borderRadius: '2px', backgroundColor: '#2cabe1' }}></span>
            <span style={{ width: 24, height: 4, borderRadius: '2px', backgroundColor: '#fdbb16' }}></span>
            <span style={{ width: 24, height: 4, borderRadius: '2px', backgroundColor: '#83c341' }}></span>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '4px' }}>
            <h1 style={{ fontSize: '24px', fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.02em', fontFamily: 'var(--font-heading)' }}>
              TBS MARKETING
            </h1>
          </div>
        </div>

        {/* Login Card */}
        <div
          style={{
            backgroundColor: '#1E293B',
            border: '1px solid #334155',
            borderRadius: '12px',
            padding: '28px 24px',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.4)'
          }}
        >
          <div style={{ fontSize: '15px', fontWeight: 700, color: '#FFFFFF', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <KeyRound size={17} color="#2cabe1" />
            <span>Sign In</span>
          </div>

          {authError && (
            <div style={{ padding: '10px 12px', backgroundColor: '#451A1A', border: '1px solid #7F1D1D', borderRadius: '6px', color: '#FCA5A5', fontSize: '12.5px', marginBottom: '16px' }}>
              {authError}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ fontSize: '12.5px', fontWeight: 500, color: '#CBD5E1', display: 'block', marginBottom: '6px' }}>Username</label>
              <div style={{ position: 'relative' }}>
                <User size={15} color="#94A3B8" style={{ position: 'absolute', left: '12px', top: '11px' }} />
                <input
                  type="text"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="admin"
                  style={{
                    width: '100%',
                    paddingLeft: '36px',
                    height: '38px',
                    backgroundColor: '#0F172A',
                    border: '1px solid #334155',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    fontSize: '13.5px'
                  }}
                />
              </div>
            </div>

            <div>
              <label style={{ fontSize: '12.5px', fontWeight: 500, color: '#CBD5E1', display: 'block', marginBottom: '6px' }}>Password</label>
              <div style={{ position: 'relative' }}>
                <Lock size={15} color="#94A3B8" style={{ position: 'absolute', left: '12px', top: '11px' }} />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="admin123"
                  style={{
                    width: '100%',
                    paddingLeft: '36px',
                    height: '38px',
                    backgroundColor: '#0F172A',
                    border: '1px solid #334155',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    fontSize: '13.5px'
                  }}
                />
              </div>
            </div>

            <button
              type="submit"
              style={{
                marginTop: '6px',
                height: '40px',
                backgroundColor: '#2cabe1',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'background-color 0.15s ease'
              }}
            >
              Sign In
            </button>
          </form>

          {/* Quick Preset Credentials Button for Pitching */}
          <div style={{ marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #334155', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: '12px', color: '#94A3B8' }}>Demo Credentials</span>
            <button
              type="button"
              onClick={handleFillDemo}
              style={{
                fontSize: '12px',
                color: '#2cabe1',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 600
              }}
            >
              Click to fill <span style={{ color: '#fdbb16' }}>admin / admin123</span>
            </button>
          </div>
        </div>



        {/* Copyright Notice */}
        <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '11.5px', color: '#475569', fontWeight: 500 }}>
          © 2026 TBS Marketing Co., Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
}
